import { defineMessages } from 'react-intl';

export default defineMessages({
    overviewTab: {
        id: '_.outstanding_view.overviewTab',
        defaultMessage: 'Overview'
    },
    repaymentsTab: {
        id: '_.outstanding_view.repaymentsTab',
        defaultMessage: 'Repayments'
    }
});
